import { render, staticRenderFns } from "./WalletCreditingPortalSelectBusiness.vue?vue&type=template&id=be9ed566&scoped=true&"
import script from "./WalletCreditingPortalSelectBusiness.vue?vue&type=script&lang=js&"
export * from "./WalletCreditingPortalSelectBusiness.vue?vue&type=script&lang=js&"
import style0 from "./WalletCreditingPortalSelectBusiness.vue?vue&type=style&index=0&id=be9ed566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9ed566",
  null
  
)

export default component.exports